import React, { FC } from 'react';

import OutboundLegacyRedirect from './OutboundLegacyRedirect';
import OutboundLegacyRedirectWithGroupId from './OutboundLegacyRedirectWithGroupId';

export interface OutboundLegacyRouteComponentProps {
  readonly match: {
    readonly params: {
      readonly groupId?: string;
    };
  };
}

type OutboundLegacyRoute = (target: string) => FC<OutboundLegacyRouteComponentProps>;
export const outboundLegacyRoute: OutboundLegacyRoute =
  (target) =>
  ({ match }) => {
    const { groupId } = match.params;

    return groupId ? (
      <OutboundLegacyRedirectWithGroupId target={target} groupId={groupId} />
    ) : (
      <OutboundLegacyRedirect target={target} />
    );
  };
